import { ToolbarButton } from "components/base";
import { NonProducingWell_Icon } from "components/icons";

import { useXdaSettingsStore } from "../../context";
import { selectShowDucWells } from "../../context/xdaSettingsSelectors";

/**
 * EVA-185 — show the surveyed, non-producing wells that cross the line (every
 * status except abandoned) as plain dots. Off by default. The flag rides on the
 * /line request, so toggling refetches; the dots never enter the XDA math and
 * never grow a polygon.
 *
 * The label says "non-producing", not "DUC": the set is every surveyed crossing
 * the drainage math excludes, which is DUCs plus idle/suspended/shut-in. The
 * internal names (`showDucWells`, `duc_wells`) keep the ticket's vocabulary.
 */
function XdaDucWellsToggle() {
  const showDucWells = useXdaSettingsStore(selectShowDucWells);
  const updateXdaSettings = useXdaSettingsStore((s) => s.updateXdaSettings);

  const handleToggle = (active: boolean) => {
    updateXdaSettings({ showDucWells: active });
  };

  return (
    <ToolbarButton
      icon={<NonProducingWell_Icon />}
      active={showDucWells}
      tooltipText={"Show Non-Producing Wells"}
      overflowLabel={"Non-Producing Wells"}
      data-testid="xda-duc-wells-toggle"
      onToggle={handleToggle}
      styleKey="xdaToolbar"
    />
  );
}

export default XdaDucWellsToggle;
